import { getUuid } from '@sibe/utilities/common';
import { HsTexturedIndexedGeometry } from '../../graphic-engine-new/geometry/textured-indexed-geometry.class';
import { HsGeometryType } from '../../graphic-engine-new/geometry/geometry-type.enum';
import { HsBufferType } from '../../graphic-render-new/enums/buffer-type.enum';
import type { HsGraphics } from '../../graphic-render-new/graphics.class';
import type { HsGraphicsBuffer } from '../../graphic-render-new/types/graphic-buffer.type';
import { HsBox } from '../../math-new/shapes/box.class';
import { HsSphere } from '../../math-new/shapes/sphere.class';
import type { HsIndexedGeometryData } from './indexed-geometry-data.class';

/**
 * Handles s make textured indexed geometry.
 */
export function hsMakeTexturedIndexedGeometry(
  graphics: HsGraphics,
  mesh: HsIndexedGeometryData
): HsTexturedIndexedGeometry | null {
  const vertices: Float32Array =
    mesh.vertices instanceof Float32Array ? mesh.vertices : Float32Array.from(mesh.vertices);
  const normals: Float32Array = mesh.normals instanceof Float32Array ? mesh.normals : Float32Array.from(mesh.normals);
  const indices: Uint32Array = mesh.indices instanceof Uint32Array ? mesh.indices : Uint32Array.from(mesh.indices);
  const uvs: Float32Array =
    mesh.uvs === undefined
      ? new Float32Array(0)
      : mesh.uvs instanceof Float32Array
      ? mesh.uvs
      : Float32Array.from(mesh.uvs);
  const box: HsBox = HsBox.makeFromArray(vertices);
  const sphere: HsSphere = HsSphere.makeSphereFromBoundingBox(box.min, box.max);
  const bufferArray: Float32Array = new Float32Array(vertices.length + normals.length + uvs.length);
  bufferArray.set(vertices);
  bufferArray.set(normals, vertices.length);
  bufferArray.set(uvs, vertices.length + normals.length);
  const buffer: HsGraphicsBuffer | null = graphics.createBuffer(bufferArray);
  const indexBuffer: HsGraphicsBuffer | null = graphics.createBuffer(indices, HsBufferType.elementBuffer);
  if (buffer === null) {
    return null;
  }
  if (indexBuffer === null) {
    return null;
  }
  const geometry: HsTexturedIndexedGeometry = new HsTexturedIndexedGeometry(
    getUuid(),
    HsGeometryType.Triangles,
    box,
    sphere,
    vertices.length,
    normals.length,
    indices.length,
    buffer,
    indexBuffer
  );
  return geometry;
}
